import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export const StaleDataDialog = ({ open, title, intro, rows, note, buttonText, onApply, applying }) => (
  <AlertDialog open={open}>
    <AlertDialogContent className="rounded-none max-w-lg" data-testid="stale-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2" data-testid="stale-dialog-title">
          <AlertTriangle size={18} className="text-amber-600" /> {title}
        </AlertDialogTitle>
        <AlertDialogDescription className="text-sm text-slate-700">{intro}</AlertDialogDescription>
      </AlertDialogHeader>
      <div className="border border-border divide-y divide-border text-sm max-h-64 overflow-y-auto">
        {rows.map((r, i) => (
          <div key={i} className="px-3 py-2 flex items-center justify-between gap-3" data-testid={`stale-change-row-${i}`}>
            {r.label ? (
              <>
                <span className="text-slate-700">{r.label}</span>
                <span className="whitespace-nowrap font-medium">
                  <span className="text-slate-500 line-through mr-2">{r.old}</span>→ {r.nue}
                </span>
              </>
            ) : (
              <span className="text-slate-700">{r.text}</span>
            )}
          </div>
        ))}
      </div>
      {note && <p className="text-xs text-muted-foreground">{note}</p>}
      <AlertDialogFooter>
        <Button onClick={onApply} disabled={applying} data-testid="stale-apply-btn" className="rounded-none brand-bg text-white w-full">
          {buttonText}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
